module.exports = __webpack_public_path__ + "img/mobilita_sicura_singolo.5292b183.jpg";